import React from "react";
import { Button } from "react-bootstrap";
import { clock } from "./clock";

const LABELS = {
  email: "Email me a code",
  sms: "Text me a code",
  totp: "Use authenticator app",
  tin: "Didn't get the code? Verify with the last 4 digits of your SSN/TIN",
};

// Offers only the methods the server listed, minus the one already showing. Quiet links in one
// wrapping row under the verify button; they stay buttons (the E2E finds them by role + name).
// `tinWaitSeconds` > 0: the SSN/TIN entry is plain text with a countdown until Oracle allows it
// (tin_available_in; docs/specs/authenticator-mfa-doc-gaps.md, part 1).
const MethodPicker = ({ methods, method, onSelect, disabled, tinWaitSeconds = 0 }) => {
  const others = methods.filter((m) => m !== method && LABELS[m]);
  if (others.length === 0) return null;
  return (
    <div className="mfa-method-links">
      {others.map((m) => (m === "tin" && tinWaitSeconds > 0 ? (
        <span key={m} className="text-muted small">
          {`Didn't get the code? You can verify with your SSN/TIN in ${clock(tinWaitSeconds)}`}
        </span>
      ) : (
        <Button key={m} variant="link" type="button" className="p-0" disabled={disabled} onClick={() => onSelect(m)}>
          {LABELS[m]}
        </Button>
      )))}
    </div>
  );
};

export default MethodPicker;
